import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import { Link } from 'react-router-dom';
import { Col, Row, Table, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faPenToSquare, faPlus, faTrashCan, faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { BulkCheckboxControl, DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from 'react-bs-datatable';
import { useParams } from "react-router-dom";
import RemoveModalToast from './removeUser';

const RoleUsersList = ({persona}) => {
  const [resp] = useState('');
  const [t] = useTranslation();
  const [data, setData] = useState([]);
  const [showSubComponent, setShowSubComponent] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [setShowModal] = useState(false);
  const [flag, setFlag] = useState(false);
  const { id } = useParams();

  const handleShowModal = (userId, name) => {
    setSelectedData({ id: userId, name, roleId: id });
    setShowSubComponent(true);
  };

  const handleSubComponentEvent = () => {
    console.log('Event triggered inside SubComponent!');
  };

  const handleConfirm = () => {
    setData(data.filter(data => data.id !== selectedData.id));
    setShowModal(false);
    setShowSubComponent(false);
  };

  const changeFlag = () => {
    setFlag(!flag);
    setShowSubComponent(false);
  };

  const fetchRoleUsers = async () => {
    const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/v1/roles/users/${id}`, { withCredentials: true })
    .catch((err) => {
      console.log(err);
    });

    setData(response?.data);
  };

  useEffect(() => {
    fetchRoleUsers();
  }, [persona]);

  useEffect(() => {
    fetchRoleUsers();
  }, [flag]);

  const headers = [
    { prop: 'checkbox', checkbox: { idProp: 'rowId', className: 'table-checkbox' }, alignment: { horizontal: 'center' } },
    { title: t('ID'), prop: 'rowId', isSortable: true, isFilterable: true },
    { title: t('name'), prop: 'name', isSortable: true, isFilterable: true },
    { title: t('email'), prop: 'email', isSortable: true, isFilterable: true },
    { title: t('createdAt'), prop: 'createdAt', isSortable: true, isFilterable: true },
    { title: t('blocked'), prop: 'blocked', alignment: { horizontal: 'center' } },
    { title: t("delete"), prop: "delete", alignment: { horizontal: "center" } },

  ];

  const body = Array.from(data || [], (data) => {
    return {
      rowId: data.id,
      name: data.username,
      email: data.email,
      blocked: !data.blocked ? <FontAwesomeIcon icon={faCircleXmark} style={{ color: "#dc3545", }} /> : <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#198754", }} />,
      createdAt: new Date(data.createdAt).toLocaleString('en-GB'),
      details: <Link to={`/${persona}/roles/details/${data.id}`}><FontAwesomeIcon icon={faCircleInfo} style={{ color: "#0d6efd", }} /></Link>,
      edit: <Link to={`/${persona}/roles/edit/${data.id}`}><FontAwesomeIcon icon={faPenToSquare} style={{ color: "#198754", }} /></Link>,
      delete: (
        <Link onClick={() => handleShowModal(data.id, data.username)}>
          <FontAwesomeIcon icon={faTrashCan} style={{ color: "#ff0000" }} />
        </Link>
      ),
    };
  });

  return (
    <div className="content">
      {resp && <p>{resp}</p>}
      {/* <Button href={`/${persona}/roles/create`} variant="success"><FontAwesomeIcon icon={faPlus} /> {t('create')}</Button> */}

      <DatatableWrapper body={body} headers={headers}
        paginationOptionsProps={{
          initialState: {
            rowsPerPage: 10,
            options: [10, 20, 30]
          }
        }}>

        <Row className="mb-4">
          <Col xs={12} className="mt-2">
            <BulkCheckboxControl />
          </Col>

          <Col xs={12} lg={4} className="d-flex flex-col justify-content-end align-items-end">
            <Filter />
          </Col>
        </Row>

        <Table className="table table-striped table-bordered">
          <TableHeader />
          <TableBody className="table-body" />
        </Table>

        <Row className="mb-4">
          <Col xs={12} sm={6} lg={4} className="d-flex flex-col justify-content-end align-items-end">
            <Pagination alwaysShowPagination paginationRange={3} />
          </Col>

          <Col xs={12} sm={6} md={{ span: 4, offset: 4 }} lg={4} className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0">
            <PaginationOptions alwaysShowPagination />
          </Col>
        </Row>

      </DatatableWrapper>

      {showSubComponent && (
        <RemoveModalToast changeFlag={changeFlag} sentData={selectedData} onEvent={handleSubComponentEvent} onConfirm={handleConfirm} />
      )}
    </div>
  );
};

export default RoleUsersList;